import { useQuery } from '@tanstack/react-query';
import { fetchNotifications } from '../api/notifications';
import { Notification } from '../types/notifications';
import { isCurrentlyActive } from '@/lib/date-utils';

export function useNotifications() {
  return useQuery<Notification[]>({
    queryKey: ['notifications'],
    queryFn: async () => {
      const response = await fetchNotifications();
      // Filter to only return notifications that are currently active
      return response.data.filter((notification) =>
        isCurrentlyActive(notification.NotificationStartDate, notification.NotificationEndDate)
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}





